import React, { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { IPatientFormValues } from '../../types';
import { IOption } from '~/ui/components/inputs/Select/types';
import { IAttendingPhysician } from '~/services/api/attendingPhysicians/types';
import { PhoneFlagDisplay } from '~/ui/components/inputs/PhoneFlag';
import Select from '~/ui/components/inputs/Select';

interface IProps {
  attendingPhysicianOptions: IOption[];
  programAttendingPhysicians: IAttendingPhysician[];
}

const AttendingPhysician: FC<IProps> = ({
  attendingPhysicianOptions,
  programAttendingPhysicians,
}) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<IPatientFormValues>();

  const attendingPhysicianId = watch('attendingPhysicianId');

  const attendingPhysician = useMemo(() => {
    if (!attendingPhysicianId) return null;

    return programAttendingPhysicians.find(item => item.id === Number(attendingPhysicianId));
  }, [attendingPhysicianId, programAttendingPhysicians]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <Select
          name="attendingPhysicianId"
          control={control}
          errors={errors}
          options={attendingPhysicianOptions}
          label="Attending Physician *"
        />
      </Grid>
      <Grid item xs={3}>
        <PhoneFlagDisplay label="Phone" placeholder="Phone" value={attendingPhysician?.phone} />
      </Grid>
      <Grid item xs={3}>
        <PhoneFlagDisplay label="Fax" placeholder="Fax" value={attendingPhysician?.fax} />
      </Grid>
      <Grid item xs={3}>
        <FormControl variant="outlined" size="small" fullWidth>
          <InputLabel shrink>Specialty</InputLabel>
          <OutlinedInput
            value={attendingPhysician?.specialty || ''}
            inputProps={{ readOnly: true }}
            label="Specialty"
            notched
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AttendingPhysician;
